
<div class="overview" *ngIf="componentToDisplay !== undefined ">
  <div class="overview__image-container">
    <div class="overview__image" *ngIf="!loading"  [@fadeIn]>
      <img [src]="getImage(componentToDisplay.Photo)" class="equipment-photo" />
    </div>
  </div>
  <div class="overview__content">
    <div class="content__primary">
      <item-group>
        <item [label]="translate('Component Name')" [primary]="true" [loading]="loading">
          {{ componentToDisplay.Name }}
        </item>
      </item-group>
    </div>
    <div class="content__secondary">
      <div class="special">
        <item-group>
          <div>
            <item  [label]="translate('Install Date')" [loading]="loading">{{ componentToDisplay.InstallDate }}</item>
          </div>
          <div>
            <item [label]="translate('Worn')" [loading]="loading">{{ componentToDisplay.PercentWorn }} %</item>
          </div>
          <div>
            <item [label]="translate('CMU')" [loading]="loading">{{ componentToDisplay.Cmu }}</item >
          </div>
          <div>
            <item [label]="translate('Make')" [loading]="loading" >{{ componentToDisplay.Brand }}</item>
          </div>
          <div>
            <item [label]="translate('Budget Life')" [loading]="loading">{{ componentToDisplay.BudgetLife }}</item>
          </div>
          <div></div>
        </item-group>
      </div>
    </div>
  </div>
</div>
